import React, { useState } from 'react'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import imageisec from '../Assests/isecurion1.png'
import { Icon } from '@iconify/react';
import ForgotIllustration from '../Assests/Forgot Illustration.png';
import buglogo from '../Assests/buglogo.png';

import "./css/LoginPage.css";
import { url } from '../constants/url'
import { useAuth } from '../Context/UserContext'


function ForgotPage() {

    const [forgotEmailError, setForgotEmailError] = useState('')
    const [disableButton, setDisableButton] = useState(false)
    const [forgotEmail, setForgotEmail] = useState('')
    const navigate = useNavigate()

    const { logout } = useAuth()

    const forgotPasswordSuccess = () => {
        toast.success("Password reset link sent .", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
        })
    }

    const forgotPasswordError = () => {
        toast.error("Please try after 3 minutes.", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
        })
    }


    // Refer users.js file for backend api code
    const handleSend = async (e) => {
        e.preventDefault()
        setDisableButton(true)
        if (forgotEmail === '') {
            setDisableButton(false)
            return setForgotEmailError("Email required");
        }
        if (!forgotEmail.includes('@')) {
            setDisableButton(false)
            return setForgotEmailError('Invalid Email');
        }
        try {
            const response = await axios.post(`${url}/sendforgotpasswordlink`, { email: forgotEmail });
            if (response.status === 200) {
                setDisableButton(false);
                setForgotEmail('');
                forgotPasswordSuccess();
                return
            }
            if (response.status === 406) {
                setDisableButton(false);
                const errorMessage = response.data.message || "Try after sometime.";
                forgotPasswordError(errorMessage);
                return
            }
            if (response.status === 440) {
                logout()
                toast.error("User logout due to inactivity", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }
        } catch (error) {
            console.log(error);

            setDisableButton(false)
            forgotPasswordError();

        }
    };

    return (
        <div className="wrap_login_layout">
            <div className="layout-box">
                <div className="half white-half">
                    <div className="innerbox">
                        <div className="inner-box">
                            <img src={ForgotIllustration} alt="Reset Illustration" className="inner-image" />
                            <p className="inner-text">No worries! Let's help you get back in.</p>
                            <p className="inner-description">
                                Enter the E-mail associated with your account and we'll send an E-mail to reset the password
                            </p>
                        </div>
                    </div>
                </div>
                <div className="half gray-half">
                    <div className='icon_center'>
                        <img src={buglogo} alt="Vulnytics" className="bugtrack-image" />

                    </div>
                    <div className="gray-inner-box">
                        <h2 className="form-heading">Forgot your password</h2>
                        <div className="input-group">
                            <Icon icon="weui:email-outlined" className="input-icon1" />
                            <input type="email" placeholder="Email address" className="form-input password-input" value={forgotEmail} onChange={(e) => {
                                setForgotEmail(e.target.value);
                                setForgotEmailError("");
                            }}>

                            </input>
                            {forgotEmailError && /\b@isecurion\.com$/.test(forgotEmail) ? null : <p>{forgotEmailError}</p>}

                        </div>
                        <button onClick={handleSend} className="signin-button">Send password Reset Link</button>
                        <Link to="/login" className="forgot-password">Back to Sign in</Link>

                    </div>
                </div>
            </div>

            <div className='loginpage_copyright'>
                <p>© 2026, ISECURION Technology and Consulting Pvt. Ltd, All Rights Reserved.</p>
            </div>
        </div>
    );
}

export default ForgotPage;
